<div id="box" [ngClass]="[type, customClass]">
  <div class="icon">
    <ng-content select="mat-icon"></ng-content>
  </div>
  <div class="text">
    <ng-content></ng-content>
  </div>
</div>
